import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/common-banner-bg-BMBchR2h.jpg'
import { useIntl } from 'react-intl';

const TravBusinessTermsOfUsePage: React.FC = () => {
  const intl = useIntl();
const tocItems: ITableOfContentItem[] = [
  { id: 'ownership', title:  intl.formatMessage({ id: 'terms.of.use.ownership.title' }) },
  { id: 'limitations-on-use-of-website', title: intl.formatMessage({ id: 'terms.of.use.limitations-on-use-of-website.title' }) },
  { id: 'right-to-contact-you', title: intl.formatMessage({ id: 'terms.of.use.right-to-contact-you.title' }) },
  { id: 'reservation-types', title: intl.formatMessage({ id: 'terms.of.use.reservation-types.title' }) },
  { id: 'relationship', title: intl.formatMessage({ id: 'terms.of.use.relationship.title' }) },
  { id: 'refusal-of-service', title: intl.formatMessage({ id: 'terms.of.use.refusal-of-service.title' }) },
  { id: 'cancellation', title: intl.formatMessage({ id: 'terms.of.use.cancellation.title' }) },
  { id: 'customer-changes-and-cancellations', title: intl.formatMessage({ id: 'terms.of.use.customer-changes-and-cancellations.title' }) },
  { id: 'additional-terms-and-conditions', title: intl.formatMessage({ id: 'terms.of.use.additional-terms-and-conditions.title' }) },
  { id: 'links-to-third-party-websites', title: intl.formatMessage({ id: 'terms.of.use.links-to-third-party-websites.title' }) },
  { id: 'exclusion-of-warranty', title: intl.formatMessage({ id: 'terms.of.use.exclusion-of-warranty.title' }) },
  { id: 'limitation-of-damages', title: intl.formatMessage({ id: 'terms.of.use.limitation-of-damages.title' }) },
  { id: 'governing-law-and-stipulation-of-venue', title: intl.formatMessage({ id: 'terms.of.use.governing-law-and-stipulation-of-venue.title' }) },
  { id: 'travel-precautions', title: intl.formatMessage({ id: 'terms.of.use.entire-agreement.title' }) },
  { id: 'entire-agreement', title: intl.formatMessage({ id: 'terms.of.use.travel-precautions.title' }) },
];

  
const sections: IContentSection[] = [
  {
    id: 'ownership',
    title: intl.formatMessage({ id: 'terms.of.use.ownership.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.ownership.paragraph.1' }),
    ],
  },
  {
    id: 'limitations-on-use-of-website',
    title: intl.formatMessage({ id: 'terms.of.use.limitations-on-use-of-website.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.limitations-on-use-of-website.paragraph.1' }),
      intl.formatMessage({ id: 'terms.of.use.limitations-on-use-of-website.paragraph.2' }),
    ],
  },
  {
    id: 'right-to-contact-you',
    title: intl.formatMessage({ id: 'terms.of.use.right-to-contact-you.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.right-to-contact-you.paragraph.1' }),
      intl.formatMessage({ id: 'terms.of.use.right-to-contact-you.paragraph.2' }),
    ],
  },
  {
    id: 'reservation-types',
    title: intl.formatMessage({ id: 'terms.of.use.reservation-types.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.reservation-types.paragraph.1' }),
      intl.formatMessage({ id: 'terms.of.use.reservation-types.paragraph.2' }),
      intl.formatMessage({ id: 'terms.of.use.reservation-types.paragraph.3' }),
      intl.formatMessage({ id: 'terms.of.use.reservation-types.paragraph.4' }),
    ],
  },
  {
    id: 'relationship',
    title: intl.formatMessage({ id: 'terms.of.use.relationship.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.relationship.paragraph.1' }),
    ],
  },
  {
    id: 'refusal-of-service',
    title: intl.formatMessage({ id: 'terms.of.use.refusal-of-service.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.refusal-of-service.paragraph.1' }),
    ],
  },
  {
    id: 'cancellation',
    title: intl.formatMessage({ id: 'terms.of.use.cancellation.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.cancellation.paragraph.1' }),
    ],
  },
  {
    id: 'customer-changes-and-cancellations',
    title: intl.formatMessage({ id: 'terms.of.use.customer-changes-and-cancellations.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.customer-changes-and-cancellations.paragraph.1' }),
    ],
  },
  {
    id: 'additional-terms-and-conditions',
    title: intl.formatMessage({ id: 'terms.of.use.additional-terms-and-conditions.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.additional-terms-and-conditions.paragraph.1' }),
    ],
  },
  {
    id: 'links-to-third-party-websites',
    title: intl.formatMessage({ id: 'terms.of.use.links-to-third-party-websites.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.links-to-third-party-websites.paragraph.1' }),
    ],
  },
  {
    id: 'exclusion-of-warranty',
    title: intl.formatMessage({ id: 'terms.of.use.exclusion-of-warranty.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.exclusion-of-warranty.paragraph.1' }),
    ],
  },
  {
    id: 'limitation-of-damages',
    title: intl.formatMessage({ id: 'terms.of.use.limitation-of-damages.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.limitation-of-damages.paragraph.1' }),
      intl.formatMessage({ id: 'terms.of.use.limitation-of-damages.paragraph.2' }),
    ],
  },
  {
    id: 'governing-law-and-stipulation-of-venue',
    title: intl.formatMessage({ id: 'terms.of.use.governing-law-and-stipulation-of-venue.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.governing-law-and-stipulation-of-venue.paragraph.1' }),
    ],
  },
  {
    id: 'entire-agreement',
    title: intl.formatMessage({ id: 'terms.of.use.entire-agreement.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.entire-agreement.paragraph.1' }),
    ],
  },
  {
    id: 'travel-precautions',
    title: intl.formatMessage({ id: 'terms.of.use.travel-precautions.title' }),
    paragraphs: [
      intl.formatMessage({ id: 'terms.of.use.travel-precautions.paragraph.1' }),
    ],
  },
];

  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'terms.of.use.headerTitle' })}
        headerSubtitle={intl.formatMessage({ id: 'terms.of.use.headerSubtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='center'
      />
    </div>
  );
};

export default TravBusinessTermsOfUsePage;
